import core from '@/core';
import { setStorage } from '@/utils/storager';

export function handleSetStorage(key, val) {
  console.log('setStorage: ', key, val);
  core.insert(val);
  setStorage(key, JSON.stringify(val));
}
